// Content loader utility for Netlify Visual Editor
import homeContent from '../../content/pages/home.json';

export interface ContentData {
  hero: any;
  features: any;
  howItWorks: any;
  benefits: any;
  navigation: any;
  footer: any;
}

export const loadContent = (): ContentData => {
  return {
    hero: homeContent.hero,
    features: homeContent.features,
    howItWorks: homeContent.howItWorks,
    benefits: homeContent.benefits,
    navigation: homeContent.navigation,
    footer: homeContent.footer,
  };
}; 